module.exports = __webpack_public_path__ + "img/immutable.dd246a57.png";